export class BaseModel {
  id: number;
  createdDate: Date | string;
  createdById: number;
  modifiedDate: Date | string;
  modifiedById: number;
}
